import { NotificationTypes, SafeAny } from '@/common/types';
import { axiosInstance } from '@/common/utils';
import { UserResponse } from '@/modules/epoch/types';

export const getPresetSettings = async ({ rootState, state, commit }: SafeAny) => {
  const url = `${rootState.env?.requestUrl.events}/user`;

  state.settings = { ...state.settings, isLoading: true, error: undefined };

  try {
    const { data } = await axiosInstance.get<UserResponse>(url);

    commit('setSettingsFromAPI', data);

    commit('user/setPreferredView', data.preferredView, { root: true });
  } catch (error: SafeAny) {
    Object.assign(state.settings, { isLoading: false, presets: [], error: error });

    commit(
      'addNotification',
      {
        i18nTitle: 'fetchError',
        type: NotificationTypes.Error,
        i18nDescription: error.message
      },
      { root: true }
    );
  }
};
